// extracted by mini-css-extract-plugin
module.exports = {"FooterCard_cells":"FooterCard_FooterCard_cells__1MEIT"};